const formatDate = (inputDate) => {
  if (!inputDate) {
    return '';
  }
  const months = {
    '01': 'Jan',
    '02': 'Feb',
    '03': 'Mar',
    '04': 'Apr',
    '05': 'May',
    '06': 'Jun',
    '07': 'Jul',
    '08': 'Aug',
    '09': 'Sep',
    10: 'Oct',
    11: 'Nov',
    12: 'Dec',
  };

  const yyyyMmDdPattern = /^\d{4}-\d{2}-\d{2}$/;
  const ddMonYyPattern = /^\d{2} [A-Za-z]{3} \d{2}$/;

  if (yyyyMmDdPattern.test(inputDate)) {
    // Convert from "YYYY-MM-DD" to "DD Mon YY"
    const [year, month, day] = inputDate.split('-');
    const monthAbbreviation = months[month];
    const yearAbbreviation = year.substring(2);
    return `${day} ${monthAbbreviation} ${yearAbbreviation}`;
  } else if (ddMonYyPattern.test(inputDate)) {
    // Convert from "DD Mon YY" to "YYYY-MM-DD"
    const parts = inputDate.split(' ');
    const day = parts[0];
    const month = Object.keys(months).find((key) => months[key] === parts[1]);
    const year = `20${parts[2]}`;
    return `${year}-${month}-${day}`;
  }

  return 'Invalid date format';
};

export default formatDate;
